export const environment = {
    production: false,
    apiURL: 'https://api-ai.myshopyglam.com',
    feURL: 'https://ai.myshopyglam.com',
       fbPixel: {
    enabled: false,
    id: '1519505962663294'
  }
  };